<video src="{{clipId}}" controls style="width: 100%; text-align: center;">
